import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { SoundEffectNode } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import {
  DEFAULT_SOUND_EFFECT,
  getSoundEffectLabel,
  isSoundEffect,
} from '../../config/soundEffects';
import { CardShell } from '../CardShell';

export const SoundEffectNodeView = memo(function SoundEffectNodeView({ data }: NodeProps<SoundEffectNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  const sound = isSoundEffect(data.sound) ? data.sound : DEFAULT_SOUND_EFFECT;

  return (
    <CardShell
      kind="soundEffect"
      accent="orange"
      title={getNodeDisplayLabel('soundEffect', displayLanguage)}
      summary={getSoundEffectLabel(sound, displayLanguage)}
    >
      <Handle type="target" position={Position.Left} className="!bg-orange-500" />
      <Handle type="source" position={Position.Right} className="!bg-orange-500" />
    </CardShell>
  );
});
